(function ($, Cobalt, undefined) {
    Cobalt.ModPositions = {
        dependentScripts: function () {
            return [{ dependency: Cobalt.Forms, name: "Cobalt.Forms"}];
        },
        initialize: function () {
            Cobalt.ModPositions.attachRemove();
            Cobalt.ModPositions.attachAddForm();
        },

        attachDialogClose: function () {
            $('#cp-modposition-question-choice').closest('.ui-dialog').bind('dialogclose', function () {
                window.location.reload();
            });
        },

        attachDialogCloseNoReload: function () {
            $('#cp-modposition-question-choice').closest('.ui-dialog').bind('dialogclose', function () {
                $(".ac_results").remove();
            });
        },

        attachRemove: function () {
            $('body').delegate('#cp-modposition-question-choice-delete', 'deleteConfirmPost', function () {
                var $link = $(this);
                var $listing = $link.closest('.modposition-question-choice');
                $link.closest('.modposition-question-choice').remove();
                $listing.closest('.ui-dialog').center();

                Cobalt.ModPositions.attachDialogClose();

                Cobalt.triggerHtmlInsert($listing.parent());
            });
        },

//        attachEdit: function () {
//            $('body').delegate('#cp-modquestion-edit', 'submit', function () { //change

//                $("#cp-modquestion-edit .modal .ui-dialog-titlebar-close").click();
//            });

//            Cobalt.runOnHtmlInsert(function () {
//                var $form = $('#cp-modquestion-edit').find('form');
//                if ($form.length < 1) {
//                    return;
//                }

//                $form.ajaxForm({
//                    beforeSubmit: function () {
//                        var valid = $form.valid();
//                        if (!valid)
//                            return false;
//                    },
//                    clearForm: false,
//                    resetForm: false,
//                    success: function (data) {
//                        var wasError = !isNaN(+data);
//                        if (wasError) {
//                            return;
//                        }
//                        Cobalt.ModPositions.attachDialogClose();

//                        var $link = $(this);
//                        var $listing = $link.closest('.modposition-question');

//                        $link.closest('.modposition-question').replaceWith(data);
//                        $listing.find('.no-results').remove();
//                        $listing.closest('.ui-dialog').center();
//                        Cobalt.triggerHtmlInsert($listing.parent());
//                    }
//                });

//                //Cobalt.ModPositions.attachDialogClose();

//            });
//        },

        attachAddForm: function () {

            $('body').delegate('#cp-modposition-question-choice form.quick-add', 'submit', function () {
                return false;
            });

            Cobalt.runOnHtmlInsert(function () {
                var $form = $('#cp-modposition-question-choice').find('form.quick-add');
                if ($form.length < 1) {
                    return;
                }

                $form.ajaxForm({
                    beforeSubmit: function () {
                        var valid = $form.valid();
                        if (!valid)
                            return false;
                    },
                    clearForm: true,
                    resetForm: true,
                    success: function (data) {
                        var wasError = !isNaN(+data);
                        if (wasError) {
                            return;
                        }
                        Cobalt.ModPositions.attachDialogClose();

                        var $listing = $('#cp-modposition-question-choice').find('.listing');
                        $listing.append(data);
                        $listing.find('.no-results').remove();
                        $listing.closest('.ui-dialog').center();
                        Cobalt.triggerHtmlInsert($listing.parent());

                    }
                });

                Cobalt.ModPositions.attachDialogClose();
            });
        }
    };
})(jQuery, Cobalt);


// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.ModPositions.js